import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { KeyingAppEnvironmentConfig } from '../configuration/keying.app.environment.config'

export enum Accept {
  CanadaReport = 'text/allegion.keying.keysystem.canada.report+csv',
  DesignReport = 'application/allegion.keying.keysystem.design.report+pdf',
  OverviewReport = 'application/allegion.keying.keysystem.overview.report+pdf',

  SiteMasterReport = 'text/allegion.keying.keysystem.sitemaster.report+csv',
  ICOMMasterKeyReport = 'text/allegion.keying.keysystem.icom.report+pdf',
  ICOMChangeKeyReport = 'text/allegion.keying.keysystem.icom.report+pdf',
  OrderDetailReport = 'application/allegion.keying.orderHistory.inbound.report+pdf',

  BittingListFullReport = 'application/allegion.keying.keysystem.bitting.list.usa.report+pdf',
  BittingListPartialReport = 'application/allegion.keying.keysystem.partial.bitting.list.usa.report+pdf',

  PinningReport = 'application/allegion.keying.keysystem.pinning.report+pdf',
  PartialPinningReport = 'application/allegion.keying.keysystem.partial.pinning.report+pdf',

  ShearlineReport = 'application/allegion.keying.keysystem.shearline.report+pdf',
  PartialShearlineReport = 'application/allegion.keying.keysystem.partial.shearline.report+pdf',
}

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  constructor(
    @Inject(HttpClient) private httpClient: HttpClient,
    private keyingAppEnvironmentConfig: KeyingAppEnvironmentConfig
  ) {}

  getReport(structureId, KeySystemId, accept: Accept): Observable<Blob> {
    const url = `${this.keyingAppEnvironmentConfig.getBaseUrl()}/structures/${structureId}/KeySystems/${KeySystemId}/Reports`

    const headers = new HttpHeaders().set('Accept', accept)

    return this.httpClient.get(url, { headers, responseType: 'blob' })
  }

  /* istanbul ignore next */
  getICOMReport(structureNo, structureId, KeySystemId, reportType, accept: Accept): Observable<Blob> {
    const url = `${this.keyingAppEnvironmentConfig.getBaseUrl()}/structures/${structureId}/KeySystems/${KeySystemId}/Reports/Icom/${structureNo}/${reportType}`

    const headers = new HttpHeaders().set('Accept', accept)

    return this.httpClient.get(url, { headers, responseType: 'blob' })
  }

  /* istanbul ignore next */
  getReportStatus(structureId, keySystemId) {
    const url = `${this.keyingAppEnvironmentConfig.getBaseUrl()}/structures/${structureId}/KeySystems/${keySystemId}/Reports/Status`
    return this.httpClient.get<any[]>(url)
  }

  getUserReportStatus(params?) {
    let paramString = this.setUserSearchString(params)
    const url = `${this.keyingAppEnvironmentConfig.getBaseUrl()}/users/GetUserReportStatus?${paramString}`
    return this.httpClient.get<any[]>(url)
  }

  private setUserSearchString(params) {
    let returnStr = ''
    for (let i = 0; i < params.length; i++) {
      returnStr += 'userids=' + params[i].userids
      if (i < params.length - 1) {
        returnStr += '&'
      }
    }
    return returnStr
  }

  downloadReport(structureId, keySystemId, reportTypeId): Observable<Blob> {
    const url = `${this.keyingAppEnvironmentConfig.getBaseUrl()}/structures/${structureId}/KeySystems/${keySystemId}/Reports/downloadReport/${reportTypeId}`
    return this.httpClient.get(url, { responseType: 'blob' })
  }
}
